import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import Routing from './Routing';
import store from './Helper/Redux/store';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import theme from './Theme';
import { PrivateRoute, ProtectedRoute } from './Helper/PrivateRoute';
import LandingPage from './Views/LandingPage';
import Main from "./Main";
import { getLocale, Il8nContext } from './Helper/i18n';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ContextNodes />
      </Provider>
    </ThemeProvider>
  );
}

function ContextNodes() {
  const storeValue = useSelector(state => state.storeState.stage)
  const [localizationTexts, setLocalizationTexts] = useState({})

  useEffect(() => {
    handleLocalization(storeValue?.currentLocalizationValue)
  }, [storeValue?.currentLocalizationValue])

  const handleLocalization = async (currentLocale) => {
    let locale = await getLocale({ translation: currentLocale, module: 'common' })
    setLocalizationTexts(locale)
  }

  return (
    <Il8nContext.Provider value={localizationTexts}>
      <React.StrictMode>
        <Router>
          <Routes>
            <Route exact path='/' element={<LandingPage />}>
              <Route exact path='LandingPages' element={<LandingPage />} />
            </Route>
            <Route exact path='/LandingPage' element={<LandingPage />} />
            <Route exact path='/Login' element={<LandingPage path={"/Login"} />} />
            <Route exact path='/SignUp' element={<LandingPage path={"/SignUp"} />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Main />
                </ProtectedRoute>
              }
            />
            {/* <PrivateRoute component={Main} /> */}
          </Routes>
          {/* <Routing /> */}
        </Router>
      </React.StrictMode>
    </Il8nContext.Provider>
  )
}

export default App;
